import type { FC } from 'react';
import { useContext } from 'react';
import Surface from '@wix/da-ds/pkg/Surface';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import DiscountRow from '../../DiscountRow';
import DiscountRowMobile from '../../SellerDiscountsMobile/DiscountRowMobile';
import DiscountRowMobileNew from '../DiscountRowMobileNew';
import { PapiSellerDiscount } from '@wix/da-papi-types';
import { StudioSection } from '../../../../../types/store';

import s from './DiscountStatusSection.scss';

interface Props {
  title: string;
  discounts: PapiSellerDiscount[];
  statusSection?: StudioSection;
}

const DiscountStatusSection: FC<Props> = ({
  title,
  discounts,
  statusSection,
}) => {
  const isMobile = useContext(MobileContext);
  const studioDiscountChanges = useFlag('studio_discounts_changes');

  const getRowComponent = () => {
    if (isMobile) {
      return studioDiscountChanges ? DiscountRowMobileNew : DiscountRowMobile;
    }
    return DiscountRow;
  };

  const RowComponent = getRowComponent();

  return (
    <div className={s['root']}>
      <div className={s['title']}>{title}</div>
      <Surface type={ThemeSurface.SECONDARY} themeOverrideOnly>
        {discounts.map((discount: PapiSellerDiscount) => (
          <RowComponent
            key={discount.discountId}
            discount={discount}
            className={s['discount-row']}
            statusSection={statusSection}
          />
        ))}
      </Surface>
    </div>
  );
};
DiscountStatusSection.displayName = 'DiscountStatusSection';

export default DiscountStatusSection;

